interface IFormatAddressProps {
  startDate: string;
  endDate: string;
}

export function formatAppointmentDate(
  appointmentTimeSlot: IFormatAddressProps | undefined,
) {
  if (appointmentTimeSlot) {
    const { endDate, startDate } = appointmentTimeSlot;
    const day = new Date(startDate).toLocaleString("pl-PL", {
      day: "numeric",
      month: "numeric",
      year: "numeric",
    });
    const start = new Date(startDate).toLocaleString("pl-PL", {
      hour: "numeric",
      minute: "numeric",
    });
    const end = new Date(endDate).toLocaleString("pl-PL", {
      hour: "numeric",
      minute: "numeric",
    });

    return `${day} / ${start}-${end}`;
  }
  return;
}
